import { DateTime, Interval } from 'luxon';
import { TimeSignal } from 'graphql/types';
import { GroupDurationStrategy } from './GroupDurationCalculator';

export class OverlapDeduplicationDurationStrategy
  implements GroupDurationStrategy {
  calculate(notes: TimeSignal[]): number {
    const notesWithStartEndTime = notes.filter((note: TimeSignal) =>
      Boolean(!note.excluded && note.startTime && note.endTime)
    );
    const notesWithOnlyDuration = notes.filter((note: TimeSignal) =>
      Boolean(
        !note.excluded && !note.startTime && !note.endTime && note.duration
      )
    );

    const intervals = notesWithStartEndTime.map((note: TimeSignal) => {
      const startTime = DateTime.fromISO(note.startTime);
      const endTime = DateTime.fromISO(note.endTime);
      return Interval.fromDateTimes(startTime, endTime);
    });
    const minimalIntervalSet = Interval.merge(intervals);
    const totalFromIntervals = minimalIntervalSet.reduce(
      (acc: number, interval: Interval) => acc + interval.length('seconds'),
      0
    );

    const totalFromDurations = notesWithOnlyDuration.reduce(
      (acc: number, note: TimeSignal) => acc + note.duration!,
      0
    );

    return totalFromDurations + totalFromIntervals;
  }
}
